var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item"},[_c('ElementItem',{staticClass:"ana-item",attrs:{"item":_vm.item},on:{"handlerUpdate":function($event){return _vm.$emit('handlerUpdate', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }